/**  score actions constants */
export const SET_LIST_SCORE = 'score/SET_LIST_SCORE';